import React from "react";
import { logos, programs } from "./utils-aboutComp";

import "./about-comp.scss";
import NewFooter from "../reusables/new-footer/NewFooter";

function AboutComp() {
  return (
    <section className="slide whiteSlide kenBurns about-comp">
      <div className="about-comp__hero">
        <h1 className="ae-1">About The Unflux</h1>
        <p className="ae-2">
          We believe that{" "}
          <strong>design is fundamental to how everything works</strong>
          —which is why we are committed to helping people think like designers;
          to apply simple and structured design principles to solve everyday
          problems efficiently.
        </p>
      </div>

      <div className="about-comp__mission ae-3">
        <div className="about-comp__mission-description">
          <h4>Our Mission</h4>
          <p>
            To empower aspiring product designers by providing high-quality,
            structured learning, expert mentorship, and hands-on training that
            prepares them for real-world challenges.
          </p>
          <p>
            We focus on both the skill of design and the business of design,
            ensuring that our participants not only master UI/UX but also
            understand how to build products that create business value.
          </p>
        </div>
        <div className="about-comp__mission-quote">
          <p>
            <strong>
              <q>
                “The Unflux is focused on educating people about product design,
                with a focus on excellence, solutions-thinking and business
                value.”
              </q>
            </strong>
          </p>
          <div className="quote-author">
            <strong>Elias Awili</strong>
            <small>Chief Facilitator</small>
          </div>
        </div>
      </div>

      <hr className="about-comp__divider ae-4" />

      <div className="about-comp__why-influx ae-5">
        <h4>Why The Unflux?</h4>
        <p>
          Whether you&apos;re a career switcher, newbie, or design expert, The
          Unflux provides the perfect set of resources for a successful career
          journey in product design.
        </p>
      </div>

      <div className="about-comp__programs ae-6">
        {programs.map(program => (
          <div className="-program" key={program.title}>
            <h6>{program.title}</h6>
            <p>{program.description}</p>
          </div>
        ))}
      </div>

      <div className="about-comp__snapshots">
        <div className="about-comp__snapshots-wall">
          <img
            className="about-comp__snap about-comp__snap--1"
            src="/assets/img/snapshots/snapshot-1.png"
            alt=""
          />
          <img
            className="about-comp__snap about-comp__snap--6"
            src="/assets/img/snapshots/snapshot-6.png"
            alt=""
          />
          <img
            className="about-comp__snap about-comp__snap--2"
            src="/assets/img/snapshots/snapshot-2.png"
            alt=""
          />
          <img
            className="about-comp__snap about-comp__snap--3"
            src="/assets/img/snapshots/snapshot-3.png"
            alt=""
          />
          <img
            className="about-comp__snap about-comp__snap--4"
            src="/assets/img/snapshots/snapshot-4.png"
            alt=""
          />
          <img
            className="about-comp__snap about-comp__snap--5"
            src="/assets/img/snapshots/snapshot-5.png"
            alt=""
          />
        </div>
      </div>

      <div className="about-comp__bottom ae-7">
        <div className="about-comp__future">
          <h4>The Future We See</h4>
          <p>
            The Unflux is not just a training program—it’s a growing ecosystem of
            tech talents. Our long-term goal is to train, mentor, and connect
            designers with high-demand opportunities in the global market.
          </p>
          <p>
            Want to be a part of this vision?{" "}
            <a href="mailto:hello@theunflux.com">Contact Us</a>
          </p>
        </div>

        <div className="about-comp__thankyou">
          <h4>Thank You!</h4>
          <p>
            Special appreciation to some of our past coaches and guest
            instructors who have dedicated their passion, time and experience to
            empower other designers. 💙
          </p>
          <div className="about-comp__coaches">
            <a className="about-comp__coach" href="https://linkedin.com/in/john-etokhana-497671119" target="_blank" rel="noopener noreferrer">
              <img
                className="about-comp__coach-photo"
                src="/assets/img/coaches/john.png"
                alt="John Etokhana"
              />
              <div className="about-comp__coach-info">
                <div className="about-comp__coach-name">
                  <span>John Etokhana</span>
                  <img src="/assets/img/linkedin-icon.png" alt="LinkedIn" />
                </div>
                <small>Rivva</small>
              </div>
            </a>
            <a className="about-comp__coach" href="https://linkedin.com/in/aniugbo-chidinma" target="_blank" rel="noopener noreferrer">
              <img
                className="about-comp__coach-photo"
                src="/assets/img/coaches/dinma.png"
                alt="Dinma Aniugbo"
              />
              <div className="about-comp__coach-info">
                <div className="about-comp__coach-name">
                  <span>Dinma Aniugbo</span>
                  <img src="/assets/img/linkedin-icon.png" alt="LinkedIn" />
                </div>
                <small>Monday.com</small>
              </div>
            </a>
            <a className="about-comp__coach" href="https://linkedin.com/in/mario-nomso-2427b211b" target="_blank" rel="noopener noreferrer">
              <img
                className="about-comp__coach-photo"
                src="/assets/img/coaches/mario.png"
                alt="Mario Nomso"
              />
              <div className="about-comp__coach-info">
                <div className="about-comp__coach-name">
                  <span>Mario Nomso</span>
                  <img src="/assets/img/linkedin-icon.png" alt="LinkedIn" />
                </div>
                <small>Kora</small>
              </div>
            </a>
            <a className="about-comp__coach" href="https://linkedin.com/in/nnamdi-awili-designer" target="_blank" rel="noopener noreferrer">
              <img
                className="about-comp__coach-photo"
                src="/assets/img/coaches/elias.png"
                alt="Elias Awili"
              />
              <div className="about-comp__coach-info">
                <div className="about-comp__coach-name">
                  <span>Elias Awili</span>
                  <img src="/assets/img/linkedin-icon.png" alt="LinkedIn" />
                </div>
                <small>Kora</small>
              </div>
            </a>
            <a className="about-comp__coach" href="https://linkedin.com/in/deborahawili" target="_blank" rel="noopener noreferrer">
              <img
                className="about-comp__coach-photo"
                src="/assets/img/coaches/debz.png"
                alt="Debz Awili"
              />
              <div className="about-comp__coach-info">
                <div className="about-comp__coach-name">
                  <span>Debz Awili</span>
                  <img src="/assets/img/linkedin-icon.png" alt="LinkedIn" />
                </div>
                <small>Quidax</small>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="about-comp__partners">
        <h4>Our Coaches, Alumni and Partners work at top companies</h4>

        <ul>
          {Array(2)
            .fill(logos)
            .flat()
            .map((Logo, index) => (
              <li key={index}>
                <Logo />
              </li>
            ))}
        </ul>
      </div>
      <NewFooter />
    </section>
  );
}

export default AboutComp;
